import { render, staticRenderFns } from "./ExpandibleAmount.vue?vue&type=template&id=20555950&scoped=true"
import script from "./ExpandibleAmount.vue?vue&type=script&lang=js"
export * from "./ExpandibleAmount.vue?vue&type=script&lang=js"
import style0 from "./ExpandibleAmount.vue?vue&type=style&index=0&id=20555950&prod&scoped=true&lang=css"
import style1 from "./ExpandibleAmount.vue?vue&type=style&index=1&id=20555950&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20555950",
  null
  
)

export default component.exports